module.exports = __webpack_public_path__ + "img/icon-evidence.db607337.svg";